export const getBenchmarkStats = (statsMap, benchmark) => {
  if (!statsMap || !benchmark) return null
  return statsMap[benchmark.id] || statsMap[benchmark.nome] || null
}
